import { toast } from 'react-hot-toast';

/**
 * Show a toast notification.
 * @param {Object} options
 * @param {'success'|'error'|'loading'|'custom'} [options.type] - Type of toast.
 * @param {string|React.ReactNode} options.message - Message to display.
 * @param {number} [options.duration] - Duration in ms (default: 4000).
 * @param {Object} [options.toastOptions] - Additional options for react-hot-toast.
 * @returns {string} Toast id
 */
export function showToast({ type = 'success', message, duration = 4000, toastOptions = {} }) {
  if (type === 'success') {
    return toast.success(message, { duration, ...toastOptions });
  } else if (type === 'error') {
    return toast.error(message, { duration, ...toastOptions });
  } else if (type === 'loading') {
    return toast.loading(message, { duration, ...toastOptions });
  } else {
    return toast(message, { duration, ...toastOptions });
  }
}

/**
 * Dismiss a toast by id or all toasts if no id is provided.
 * @param {string} [toastId]
 */
export function dismissToast(toastId) {
  toast.dismiss(toastId);
}

/**
 * Promise toast helper for async actions.
 * @param {Promise} promise
 * @param {Object} messages { loading, success, error }
 * @param {Object} [toastOptions]
 * @returns {Promise}
 */
export function toastPromise(promise, messages, toastOptions = {}) {
  return toast.promise(promise, messages, toastOptions);
}
